import React from "react";
import { motion } from "framer-motion";
import { IoWarningOutline } from "react-icons/io5";
import CommonModal from "../comman/modal/Modal";

const ConfirmationModal = ({ isOpen, onClose, onConfirm, title, message, data }) => {
  if (!isOpen) return null;

  return (
    <CommonModal isOpen={isOpen} onClose={onClose} title={title || "Confirm Action"}>
      <motion.div
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        exit={{ scale: 0.8, opacity: 0 }}
        transition={{ duration: 0.2 }}
        className="p-6 flex flex-col items-center space-y-4"
      >
        {/* Warning Icon */}
        <div className="text-red-500 text-5xl">
          <IoWarningOutline />
        </div>

        {/* Message */}
        <p className="text-gray-800 text-center">{message || "Are you sure you want to delete this item?"}</p>

        {/* Data Preview */}
        {data && (
          <div className="w-full border p-4 rounded-lg bg-gray-50 text-gray-700 space-y-1">
            {Object.entries(data).map(([key, value]) => (
              <div key={key} className="flex justify-between">
                <span className="font-semibold">{key.replace("_", " ").toUpperCase()}:</span>
                <span>{value?.toString()}</span>
              </div>
            ))}
          </div>
        )}

        {/* Action Buttons */}
        <div className="flex justify-center gap-3 mt-2">
          <button
            onClick={onClose}
            className="px-4 py-2 rounded-lg bg-gray-300 hover:bg-gray-400 transition"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className="px-4 py-2 rounded-lg bg-red-500 text-white hover:bg-red-600 transition"
          >
            Delete
          </button>
        </div>
      </motion.div>
    </CommonModal>
  );
};

export default ConfirmationModal;
